/* eslint react/no-unescaped-entities: 0 */
/* eslint react/display-name: 0 */
import React, { Component } from "react";
import ImportCompressorsContent from "./ImportCompressorsContent";

export default class extends Component {
  static propTypes = ImportCompressorsContent.propTypes;

  /**
   * {@inheritdoc}
   */
  render() {
    return (
      <div>
        <p>
          Um den Import Ihrer Kompressoren durchzuführen, müssen die Daten im
          ODS- oder TSV-Format gespeichert werden und die folgende Struktur einhalten:
        </p>

        <ul>
          <li>Kunden-Nr.</li>
          <li>Standort-Nr.</li>
          <li>Anlagen Nr.</li>
          <li>Markierung</li>
          <li>Bezeichner num <i>(optional)</i></li>
          <li>Seriennummer <i>(optional)</i></li>
          <li>Typ</li>
          <li>Klassifikation</li>
          <li>Marke <i>(optional)</i></li>
        </ul>

        <p>{this.props.downloadSample}</p>

        <p>
          Nach der Integration erhalten Sie eine Zusammenfassung, die Sie über
          die Anzahl der erstellten oder aktualisierten Einheiten informiert.
          Zudem wird eine Anomalie-Datei bereitgestellt, die nicht integrierte
          Zeilen und die Gründe für die Ablehnung enthält.
        </p>

        <p>Mögliche Anomaliegründe sind:</p>

        <ul>
          <li>Fehlende Pflichtdaten</li>
          <li>Nicht vorhandener Typ</li>
          <li>Nicht vorhandenes Klassifikation</li>
          <li>Nicht vorhandene Marke</li>
        </ul>
      </div>
    );
  }
}
